<template>
	<div class="newcenter">
		
			<div class="img clearfix">
				<img :src="banner"/>
			</div>
			<!--路径-->
			<div class="container">
				<div class="path">
					<el-breadcrumb separator-class="el-icon-arrow-right">
					  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					  	<el-breadcrumb-item>新闻中心</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				
				<!--内容-->
				<div class="content">
					<div class="title">
						<ul>
							<li @click="selItem(item.item_id)" 
							:class="itemId==item.item_id?'active':''"
							v-for="(item,index) in navlist"
							:id="'news_'+item.item_id"
							:key="index" >
							{{item.item_name}}
							</li>
						</ul>
					</div>
					<router-view/>
				</div>
				<newsList ref="id"></newsList>
			</div>
			
	
		
	</div>
</template>

<script>
	import newsList from './Ncom/NewsList';
	export default {
		components:{newsList},
		data(){
			return{
				msg:'newcenter',
				navlist: [],
				itemId:'',
				sel:'',
				banner:''
			}
		},
		methods:{
			selItem(item) {
				$('.active').removeClass('active');
				$('#news_'+item).addClass('active');
				this.itemId = item;
				this.$refs.id.getNewsList(item);
			},
			getData(){
				this.itemId = this.$route.query.id;
			},
			getNewsNav(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.newsNavApi,
					data: {}
				})
				.then((res) => {
					this.navlist = res.data.data;
					if(this.navlist[0] && !this.itemId){
						this.selItem(this.navlist[0].item_id);
						this.itemId = this.navlist[0].item_id;
					}else{
						this.selItem(this.itemId);
					}
				})
				.catch((err) => {
					console.log(err)
				})
			},
			getBanner(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getBannerApi+'3',
					data: {}
				})
				.then((res) => {
					this.banner = res.data.data.banner3;
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.getData();
			this.getNewsNav();
			this.getBanner();
		}

	}
</script>

<style lang="less" scoped="scoped">
@import url("../../../styles/main.less");
.newcenter{
	.img{
		width:100%;
		overflow:hidden;
		position:relative;
		.height(300);
		img{
			width: 150%;
			height: 100%;
			position:absolute;
			left:-20%;
		}
	}
	.container{
		.padding-left(20);
		.padding-right(20);
		.path{
			.margin-top(20);
			.margin-bottom(20);
			i{
				.font-size(20);
			}
			span{
				color: #00A0FF;
			}
			.news{
				.width(100);
				.height(40);
				/*border: 1px solid salmon;*/
				color: forestgreen;
				.margin-left(10);
				.margin-right(10);
			}
		}
		.content{
			.margin-top(50);
			.title{
				text-align: center;
				ul{
					li{
						display: inline-block;
						.padding(10,20,10,20);
						background: #eee;
						.font-size(30);
						text-align: center;
					}
					.active{
						background: #00A0FF;
						color: #fff;
					}
				}
				P{
					.margin-top(50);
					.font-size(26);
					color: #00A0FF;
				}
				h3{
					.margin-top(10);
					.font-size(26);
					font-weight: 600;
					.margin-bottom(50);
				}
			}
		}
	}
	
}
</style>


// WEBPACK FOOTER //
// src/components/pages/NewCenter/NewCenter.vue